
export default {
    name: 'FixedButtonWidget',

    mounted() {
        this.setHeaders();
    },

    methods: {
        setHeaders() {
            const host = window.location.host;

            const element = document.createElement('script');
            element.innerHTML = (function (d, w) {
                const n = d.getElementsByTagName('script')[0]; const
                    s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = `https://api.macroserver.ru/estate/embedjs/?domain=${host}`; n.parentNode.insertBefore(s, n);
            }(document, window));
            document.body.appendChild(element);
        },
    },
};
